import { IAttachmentResponse } from '../model/types/tasks';

export function isAttachmentResponse(obj: unknown): obj is IAttachmentResponse {
    return !!obj && typeof obj === 'object' && 'original_url' in obj;
}
